export default __webpack_public_path__ + "static/media/banefits-img-3.8b64cf86.png";